import { render, staticRenderFns } from "./EnterNewPerson.vue?vue&type=template&id=b33786da"
import script from "./EnterNewPerson.vue?vue&type=script&lang=js"
export * from "./EnterNewPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports